import React, { useState } from 'react';
import '../css/UserEditModal.css';
import { useAlert } from '../../providers/AlertProvider'
import { form } from 'framer-motion/client';
import logger from "../../utils/logger";

const UserEditModal = ({ theme, user, isOpen, onClose, onSubmit, group, vehicles, canEdit = true }) => {
    const { showAlert } = useAlert();

    const isSingleColumn = group === 'SERVICE';
    logger.log('Group:', group, 'isSingleColumn:', isSingleColumn); // Add this line for debugging
    
    const [formData, setFormData] = useState({
        id: user.id || '',
        name: user.name || '',
        surname: user.surname || '',
        email: user.email || '',
        phone: user.phone || '',
        address: user.address || '',
        licence: user.licence || '',
        licence_expiry: user.licence_expiry || '',
        licence_check: user.licence_check || '',
        tacho: user.tacho || '',
        tacho_expiry: user.tacho_expiry || '',
        cpc_expiry: user.cpc_expiry || '',
        status: user.status || '',
        group: user.group || '',
        truck_id: user.truck_id || '',
        pin: user.pin || '',
        spot_unit: user.spot_unit || '',
        holidays: user.holidays || '',
        timesheets: user.timesheets || false,
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const validatePrice = () => {
        // Check if spot_unit is provided and validate format
        if (formData.spot_unit && formData.spot_unit.trim() !== '') {
            // Check if it's a whole number without decimal places
            if (/^\d+$/.test(formData.spot_unit)) {
                showAlert({
                    message: 'Spot unit must include decimal places (e.g., 25.00)',
                    type: 'danger',
                    buttons: [{ label: 'Close', type: 'primary' }],
                });
                return false;
            }
            // Check if it doesn't match the proper decimal format
            if (!/^\d+\.\d{2}$/.test(formData.spot_unit)) {
                showAlert({
                    message: 'Invalid spot unit format. Please use format like [25.00]',
                    type: 'danger',
                    buttons: [{ label: 'Close', type: 'primary' }],
                });
                return false;
            }
        }
        return true;
    };

    const handleSubmit = () => {
        // validate spot price
        if (!validatePrice()) return;

        onSubmit(formData);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div id={theme} className="overlay">
            <div className="modal-container">
                <h2>{canEdit ? 'Edit Account' : 'View Account Details'}</h2>
                <fieldset disabled={!canEdit} style={{ border: 'none', padding: 0, margin: 0, display: 'contents' }}>
                <form className="form two-column">

                    {/* Name or Company */}
                    <div className="input-group">
                        <label>{(formData.group === 'SERVICE' || formData.group === 'CUSTOMER') ? 'Company' : 'First Name'}</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                            className="input"
                        />
                    </div>

                    {(formData.group !== 'SERVICE' && formData.group !== 'CUSTOMER') && (
                        <>
                            {/* Surname */}
                            <div className="input-group">
                                <label>Surname</label>
                                <input
                                    type="text"
                                    name="surname"
                                    value={formData.surname}
                                    onChange={handleInputChange}
                                    className="input"
                                />
                            </div>

                            {/* Licence */}
                            <div className="input-group">
                                <label>Licence No</label>
                                <input
                                    type="text"
                                    name="licence"
                                    value={formData.licence}
                                    onChange={handleInputChange}
                                    className="input"
                                />
                            </div>

                            {/* Tacho */}
                            <div className="input-group">
                                <label>Tacho No</label>
                                <input
                                    type="text"
                                    name="tacho"
                                    value={formData.tacho}
                                    onChange={handleInputChange}
                                    className="input"
                                />
                            </div>



                            {/* Licence Expiry */}
                            <div className="input-group">
                                <label>Licence Expiry</label>
                                <input
                                    type="date"
                                    name="licence_expiry"
                                    value={formData.licence_expiry}
                                    onChange={handleInputChange}
                                    className="input"
                                />
                            </div>


                            {/* Tacho Expiry */}
                            <div className="input-group">
                                <label>Tacho Expiry</label>
                                <input
                                    type="date"
                                    name="tacho_expiry"
                                    value={formData.tacho_expiry}
                                    onChange={handleInputChange}
                                    className="input"
                                />
                            </div>


                            {/* CPC Expiry */}
                            <div className="input-group">
                                <label>CPC Expiry</label>
                                <input
                                    type="date"
                                    name="cpc_expiry"
                                    value={formData.cpc_expiry}
                                    onChange={handleInputChange}
                                    className="input"
                                />
                            </div>


                            {/* Licence Check */}
                            <div className="input-group">
                                <label>Licence Check</label>
                                <input
                                    type="date"
                                    name="licence_check"
                                    value={formData.licence_check}
                                    onChange={handleInputChange}
                                    className="input"
                                />
                            </div>

                        </>
                        )}

                    {/* Address */}
                    <div className="input-group">
                        <label>Address</label>
                        <textarea
                            name="address"
                            value={formData.address}
                            onChange={handleInputChange}
                            className="input"
                        />
                    </div>

                    {/* Phone number */}
                    <div className="input-group">
                        <label>Phone Number</label>
                        <input
                            type="text"
                            name="phone"
                            value={formData.phone}
                            onChange={handleInputChange}
                            className="input"
                        />
                    </div>

                    {/* Email */}
                    <div className="input-group">
                        <label>Email</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            className="input"
                        />
                    </div>

                    {/* Spot Unit */}
                    {formData.group === 'SERVICE' && (
                    <div className="input-group">
                        <label>Spot Hire Price £</label>
                        <input
                            type="text"
                            placeholder='0.00'
                            name="spot_unit"
                            value={formData.spot_unit}
                            onChange={handleInputChange}
                            className="input"
                        />
                    </div>
                    )}

                    {/* Pin */}
                    {(formData.group !== 'SERVICE' && formData.group !== 'CUSTOMER') && (
                    <div className="input-group">
                        <label>Pin (DD/MM)</label>
                        <input
                            type="text"
                            name="pin"
                            placeholder='DD/MM'
                            value={formData.pin}
                            onChange={handleInputChange}
                            className="input"
                        />
                    </div>
                    )}

                    {/* Holiday entitlement */}
                    {(formData.group !== 'SERVICE' && formData.group !== 'CUSTOMER') && (
                    <div className="input-group">
                        <label>Holiday Entitlement</label>
                        <input
                            type="text"
                            name="holidays"
                            placeholder='Annual Entitlement [20]'
                            value={formData.holidays}
                            onChange={handleInputChange}
                            className="input"
                        />
                    </div>
                    )}

                    {/* Vehicle */}
                    {(formData.group !== 'SERVICE' && formData.group !== 'CUSTOMER') && (
                        <div className="input-group">
                            <label>Vehicle</label>
                            <select
                                name="truck_id"
                                value={formData.truck_id}
                                onChange={handleInputChange}
                                className="input"
                            >
                                <option value="">Select Vehicle</option>
                                {vehicles.map((vehicle) => (
                                    <option key={vehicle.id} value={vehicle.id}>
                                        {vehicle.reg}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    {/* Status */}
                </form>

                {/* Timesheets Toggle - Bottom Center */}
                {(formData.group !== 'SERVICE' && formData.group !== 'CUSTOMER') && (
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        padding: '15px 0',
                        borderTop: `1px solid ${theme === 'dark' ? '#444' : '#eee'}`,
                        borderBottom: `1px solid ${theme === 'dark' ? '#444' : '#eee'}`,
                        margin: '10px 0'
                    }}>
                        <div className="checkbox-container" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <input
                                type="checkbox"
                                name="timesheets"
                                checked={formData.timesheets}
                                onChange={(e) => setFormData(prev => ({ ...prev, timesheets: e.target.checked }))}
                                style={{
                                    accentColor: theme === 'dark' ? '#007acc' : '#0078d4',
                                    transform: 'scale(1.2)'
                                }}
                            />
                            <label style={{ 
                                margin: 0, 
                                fontWeight: '500',
                                color: theme === 'dark' ? '#ffffff' : '#333333'
                            }}>
                                Generate Timesheets
                            </label>
                            <span style={{
                                fontSize: '0.9em',
                                color: theme === 'dark' ? '#cccccc' : '#666666',
                                fontStyle: 'italic'
                            }}>
                                {formData.timesheets ? 'Timesheet will be generated' : 'No timesheet generation'}
                            </span>
                        </div>
                    </div>
                )}
                </fieldset>

                {/* Buttons */}
                <div className="button-group">
                    {canEdit && (
                        <button onClick={handleSubmit} className="submit-button">
                            Update
                        </button>
                    )}
                    <button onClick={onClose} className="close-button" style={!canEdit ? { width: '100%' } : {}}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UserEditModal;
